import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import Glide from '@glidejs/glide';

class Webslider extends WebComponent {
  constructor(props) {
    super(props);
    this.webslider = null;
  }

  didMount() {
    this.webslider = new Glide(this.element, this.props).mount();
  }

  willUnMount() {
    this.webslider.destroy();
  }
}

Webslider.defaultProps = {
  type: 'carousel',
  startAt: 0,
  perView: 1,
  focusAt: 0,
  gap: 0,
  autoplay: 4000,
  hoverpause: true,
  keyboard: false,
  bound: false,
  swipeThreshold: 80,
  dragThreshold: 1,
  perTouch: 1,
  touchRatio: 0,
  touchAngle: 45,
  animationDuration: 600,
  rewind: false,
  rewindDuration: 800,
  animationTimingFunc: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
  direction: 'ltr',
  peek: 0,
  throttle: 25,
  breakpoint: {},
  classes: {
    direction: {
      ltr: 'webslider--ltr',
      rtl: 'webslider--rtl',
    },
    slider: 'webslider--slider',
    slide: 'webslider__item',
    bullet: 'webslider__bullet',
    carousel: 'webslider--carousel',
    swipeable: 'webslider--swipeable',
    dragging: 'webslider--dragging',
    cloneSlide: 'webslider__item--clone',
    activeNav: 'webslider__bullet--active',
    activeSlide: 'webslider__item--active',
    disabledArrow: 'webslider__arrow--disabled',
  },
};

export default Webslider;



// WEBPACK FOOTER //
// ./fe/web-hasicovoOnline/src/js/components/Webslider.js